import type { HeroSlide } from '@/types/content';

export const heroSlides: HeroSlide[] = [
  {
    id: 'hero-01',
    filmId: 'mirror-hotel',
    kicker: '本月焦点 · 新作',
    headline: '镜中旅馆',
    description:
      '同一间旅馆客房，三个视角，一段被反复改写的关系。导演尹度贤在有限空间里完成了一次精密的叙事实验。',
    image:
      'https://readdy.ai/api/search-image?query=wide%20cinematic%20editorial%20scene%20of%20a%20dark%20elegant%20hotel%20corridor%20with%20mirrors%20reflecting%20warm%20amber%20lamps%2C%20long%20shadows%2C%20atmospheric%20haze%2C%20deep%20charcoal%20and%20muted%20crimson%20tones%2C%20fine%20film%20grain%2C%20moody%20low%20key%20lighting%2C%20large%20empty%20negative%20space%20on%20the%20left%2C%20no%20text&width=1600&height=900&seq=at-hero-mirror-hotel&orientation=landscape',
  },
  {
    id: 'hero-02',
    filmId: 'before-dawn',
    kicker: '艺术影像 · 极昼',
    headline: '晨光之前',
    description:
      '在几乎没有黑夜的夏天，两个人重新学习如何入睡。大量广角全景与极少的对白，把人的尺度放得很小。',
    image:
      'https://readdy.ai/api/search-image?query=wide%20cinematic%20editorial%20landscape%20of%20an%20icelandic%20coast%20with%20a%20small%20wooden%20cabin%20under%20a%20pale%20midnight%20sun%2C%20low%20mist%20over%20black%20sand%2C%20deep%20charcoal%20and%20muted%20warm%20tones%2C%20fine%20film%20grain%2C%20large%20empty%20negative%20space%2C%20no%20text&width=1600&height=900&seq=at-hero-before-dawn&orientation=landscape',
  },
  {
    id: 'hero-03',
    filmId: 'her-account',
    kicker: '纪实观察 · 口述史',
    headline: '她的自述',
    description:
      '六位从业者的口述史，关于选择、边界与自我叙述。导演只做一件事：把说话的时间完整地留给她们。',
    image:
      'https://readdy.ai/api/search-image?query=wide%20cinematic%20editorial%20scene%20of%20an%20empty%20interview%20room%20with%20a%20single%20chair%2C%20a%20microphone%20stand%20and%20a%20soft%20key%20light%20cutting%20through%20smoke%2C%20deep%20charcoal%20and%20muted%20crimson%20tones%2C%20fine%20film%20grain%2C%20moody%20low%20key%20lighting%2C%20no%20text&width=1600&height=900&seq=at-hero-her-account&orientation=landscape',
  },
];